<template>
  <el-form ref="form" :model="form" :rules="updata" label-width="120px">
    <el-form-item label="新密码">
      <el-input v-model="form.newPassword" type="password"></el-input>
    </el-form-item>
    <el-form-item label="确认新密码">
      <el-input v-model="form.confirmPassword" type="password"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="default" @click="handleChangepwd">提交</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
import API from '../apis/account'
export default {
  data () {
    var validateConfirmPwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      message: '修改密码',
      form: {
        newPassword: '',
        confirmPassword: ''
      },
      updata: {
        newPassword: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
        confirmPassword: [{ required: true, message: '请再次输入新密码', trigger: 'blur' },
        { validator: validateConfirmPwd, trigger: 'blur' }]
      }
    };
  },
  methods: {
    handleChangepwd () {
      let that = this;
      this.$refs.form.validate((valid) => {
        if (valid) {
          let Updataparams = {
            newPassword: this.form.newPassword,
            confirmPassword: this.form.confirmPassword
          }
          API.changePassword(Updataparams).then((result) => {
            if (result.code == 0) {
              that.$message.success({ showClose: true, message: '更改成功', duration: 2000 });
              this.$refs['form'].resetFields();
            } else {
              that.$message.error({ showClose: true, message: '更改失败', duration: 2000 });
            }
          }, function (err) {
            that.$message.error({ showClose: true, message: err.toString(), duration: 2000 });
          }).catch(function (error) {
            that.$message.error({ showClose: true, message: '请求出现异常', duration: 2000 });
          })
        }
      })
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/views/ChangePassword.vue